import { getFormattedDate } from '../../../../helpers/localize';
import DownloadTableFile from '../../../Shared/Table/widgets/TopBar/DownloadTableFile';
import { useSelector } from 'react-redux';
import { TABLE_KEYS } from '../../../../redux_store';

const TableActions = (props) => {
  const { isDistributionSponsor } = useSelector((state) => state.user);
  const tableKey = isDistributionSponsor ? TABLE_KEYS.botActivitiesDSTable : TABLE_KEYS.botActivitiesTable;

  return props.isPatientPage ? <></> : <>
    <DownloadTableFile
      fileName={`Bot Activity ${getFormattedDate(new Date(Date.now()))}.csv`}
      endpoint={'/export-ecw-activities.csv'}
      tableKey={tableKey}
      {...props}
    />
  </>;
};

export default TableActions;
